import React from 'react';
import styles from './Highlight.module.css';

const HighlightPage = () => {
  const videoUrl = 'https://ihcmlcnktfrrojtkrtbt.supabase.co/storage/v1/object/public/asset/videos/demo.webm';

  const handleDownload = () => {
    // 비디오 다운로드 로직
    const link = document.createElement('a');
    link.href = videoUrl;
    link.download = '하이라이트.webm';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className={styles.wrapper}>
    <div className={styles.container}>
      <div className={styles.videoContainer}>
        <video 
          controls 
          autoPlay
          className={styles.videoPlayer}
        >
          <source src={videoUrl} type="video/webm" />
          브라우저가 비디오 재생을 지원하지 않습니다.
        </video>
      </div>

      <div className={styles.infoContainer}>
        <div className={styles.infoHeader}>
          <button 
            className={styles.downloadButton}
            onClick={handleDownload}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.downloadIcon}>
              <path d="M12 16L12 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M9 13L12 16L15 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M20 16V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            다운로드
          </button>
        </div>
        
        <p className={styles.infoMessage}>
          매치 종료 후 21일동안 영상을 시청할 수 있습니다. 영상 소장을 위해 미리 다운로드하세요.
        </p>
      </div>
    </div>
    </div>
  );
};

export default HighlightPage; 